/**
 * 見学予約ステップ1: 選んだ日付に空きのある時間枠だけを選べるようにする。
 *
 * サーバー側（ReservationCalendar::isSlotAcceptable）が最終判断を持っているので、
 * ここは「埋まっている枠を押せてしまい、送信して初めて弾かれる」のを防ぐための表示補助。
 * data-selectable-slots が無いとき（受入数を設けていない店舗）は何もしない。
 */
const main = () => {
    document.querySelectorAll('.js-reserve-slots').forEach((root) => {
        const raw = root.dataset.selectableSlots;
        if (!raw) return;

        let selectable;
        try {
            selectable = JSON.parse(raw);
        } catch {
            return;
        }

        const timeInputs = Array.from(root.querySelectorAll('input[name="desired_time"]'));
        if (timeInputs.length === 0) return;

        const dateInputs = Array.from(document.querySelectorAll('input[name="desired_date"]'));

        const apply = (date) => {
            // 日付未選択のうちは絞り込まない（どの枠が取れるかは日付が決まってから）
            const allowed = date ? selectable[date] : null;

            timeInputs.forEach((input) => {
                const disabled = Array.isArray(allowed) && !allowed.includes(input.value);
                input.disabled = disabled;
                // 選択済みの枠が埋まっていたら外す。選べない値を持ったまま送信させない
                if (disabled && input.checked) input.checked = false;
            });
        };

        const checkedDate = dateInputs.find((input) => input.checked);
        apply(checkedDate ? checkedDate.value : null);

        dateInputs.forEach((input) => {
            input.addEventListener('change', () => {
                if (input.checked) apply(input.value);
            });
        });
    });
};

export default main;
